import React from 'react';
import { Route, Routes } from 'react-router-dom';
import { Navbar } from './components/Navbar';
import { BackgroundImage } from './components/BackgroundImage';
import { Home } from './components/Home';
import { About } from './components/About';
import { Contact } from './components/Contact';
import { SecurityDepositInsurance } from './components/SecurityDepositInsurance';
import { TenantLegalLiability } from './components/TenantLegalLiability';
import { ExternalRedirect } from "./components/ExternalRedirect";
import { Footer } from './components/Footer';
import 'bootstrap/dist/css/bootstrap.min.css';
import './App.css';

const MainContent: React.FC = () =>
    <>
        <Navbar/>
        <BackgroundImage/>
        <main className="flex-grow-1 bg-white mt-2">
            <Routes>
                <Route path="/" element={<Home/>}/>
                <Route path="/about" element={<About/>}/>
                <Route path="/contact" element={<Contact/>}/>
                <Route path="/security-deposit-insurance" element={<SecurityDepositInsurance/>}/>
                <Route path="/tenant-legal-liability" element={<TenantLegalLiability/>}/>
                <Route path="/claims" element={<ExternalRedirect to="https://claims.yourrenterskit.com"/>}/>
                <Route path="/reimbursement" element={<ExternalRedirect to="https://claims.yourrenterskit.com"/>}/>
            </Routes>
        </main>
        <Footer/>
    </>

export const App: React.FC = () =>
    <div className="App d-flex flex-column min-vh-100">
        <MainContent/>
    </div>

